module.exports = __webpack_public_path__ + "static/media/account_icon.ee1cbc8e.svg";